import { LOCALES } from "../locales";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [LOCALES.HEBREW]: {
    //COMMON
    commonBackToTheMainPage: "חזרה לעמוד הראשי",
    commonBackToOrganizersPage: "חזרה לרשימת המארגנים",
    hideRows: "10 שורות ראשונות הוסתרו",

    //HEADER
    headerDevicesConnected: "מחובר לפאנל",
    headerOptToUsers: "הגדר משתמש OTP",
    headerOpenEvents: "אירועים",
    headerOpenProfiles: "פרופילים",
    headerOpenOrganizers: "מארגנים",
    headerOpenOrganizersRequest: "בקשות מארגנים",
    headerOpenDocuments: "מסמכים",
    headerOpenTransactions: "עסקאות",
    headerOpenMarketingPersons: "אנשי שיווק",
    headerOpenStaticOtp: "OTP קבוע",
    headerOpenOtpBypass: "עקיפת קאפצ׳ה",
    headerOpenRobotSmsPolicy: "מדיניות רובוט SMS",
    headerTotalMoney: "סך הכל כסף",
    headerTotalFee: "עמלה כוללת",
    headerTransactionTotalFee: "עמלת עסקה",
    headerTransactionTotalFastFee: "עמלת עסקה מהירה",
    headerTransactionTotalEarlyFee: "עמלת עסקה מוקדמת",
    headerTransactionTotalAdminWithdrawalFee: "עמלת משיכת מנהל",
    headerDownloadReport: "דו״ח",
    headerCancelTicket: "ביטול כרטיס",
    headerCancelTicketByUuid: "ביטול כרטיס לפי UUID",

    // SEND OTP MODAL
    otpCode: "קוד אופטימיזציה למשתמש",
    setOtp: "הגדר OTP",
    otpSetSuccess:
      "קוד OTP לעג למשתמש למשך 60 הדקות הבאות והקוד הועתק ללוח שלך",
    otpSetFailed: "קוד OTP נכשל",
    otpPhoneInvalid: "מספר טלפון לא תקין",
    otpIsStatic: "השתמש בקוד OTP זה לצמיתות",
    otpIsStaticHint:
      "הקוד לא יפוג. מספר זה לא יקבל SMS, וואטסאפ או הודעות טלגרם, ולא יוצג לו reCAPTCHA בהתחברות.",
    otpSetStaticSuccess:
      "קוד OTP קבוע הוגדר למשתמש, הוא לא יפוג והועתק ללוח שלך",

    // STATIC OTP SCREEN
    staticOtpScreenTitle: "משתמשים עם OTP קבוע",
    otpListPhone: "טלפון",
    otpListUser: "משתמש",
    otpListNotRegistered: "טרם נרשם",
    otpListDeleted: "נמחק",
    staticOtpCode: "קוד",
    staticOtpSetAt: "הוגדר בתאריך",
    staticOtpLastLogin: "התחברות אחרונה",
    otpListActions: "פעולות",
    staticOtpRemove: "הסר OTP קבוע",
    staticOtpRemoveConfirm:
      "הקוד עבור {phone} יפסיק לעבוד, ובהתחברות הבאה יישלח OTP רגיל.",
    staticOtpRemoveSuccess: "OTP קבוע הוסר",
    staticOtpRemoveFailed: "הסרת OTP קבוע נכשלה",
    staticOtpCodeCopied: "הקוד הועתק",
    staticOtpAdd: "הוסף OTP קבוע",
    staticOtpEdit: "ערוך OTP קבוע",
    staticOtpEditButton: "ערוך",
    staticOtpSave: "שמור",
    staticOtpCodeLabel: "קוד OTP (6 ספרות)",
    staticOtpCodeInvalid: "הקוד חייב להכיל 6 ספרות",
    staticOtpGenerateCode: "צור קוד אקראי",
    staticOtpUpdateSuccess: "OTP קבוע עודכן, הקוד הועתק ללוח שלך",
    otpListSearch: "חיפוש לפי טלפון, שם או אימייל",

    // CAPTCHA BYPASS SCREEN
    otpBypassScreenTitle: "טלפונים ללא קאפצ׳ה ומגבלות OTP",
    otpBypassAdd: "הוסף טלפון",
    otpBypassHint:
      "מספר זה עדיין יקבל קוד אמיתי ב-SMS, וואטסאפ או טלגרם, אבל ללא reCAPTCHA, מגבלות בקשות OTP וחסימות.",
    otpBypassAddedAt: "נוסף בתאריך",
    otpBypassActive: "פעיל",
    otpBypassAddSuccess: "הטלפון נוסף",
    otpBypassAddFailed: "הוספת הטלפון נכשלה",
    otpBypassUpdateFailed: "עדכון הטלפון נכשל",
    otpBypassRemove: "הסר",
    otpBypassRemoveConfirm: "{phone} יחזור לקאפצ׳ה ולמגבלות OTP הרגילות.",
    otpBypassRemoveSuccess: "הטלפון הוסר",
    otpBypassRemoveFailed: "הסרת הטלפון נכשלה",

    // ROBOT SMS POLICY SCREEN
    robotSmsPolicyTitle: "רובוט SMS - טופס הצהרה לרשימות פרטיות",
    robotSmsPolicyHint:
      "מפיקים קוראים ומאשרים את הגרסה הפעילה לפני שהם מעלים רשימות נמענים משלהם. קובץ חדש הופך מיד לגרסה הפעילה וכל המפיקים צריכים לאשר אותו מחדש. אי אפשר למחוק גרסאות - יש להשבית גרסאות שאסור להשתמש בהן.",
    robotSmsPolicyActiveSummary: "גרסה פעילה: {version} · אושרה על ידי {count}",
    robotSmsPolicyUpload: "העלאת גרסה חדשה",
    robotSmsPolicyVersion: "גרסה",
    robotSmsPolicyStatus: "סטטוס",
    robotSmsPolicyStatusActive: "פעילה",
    robotSmsPolicyStatusDisabled: "מושבתת",
    robotSmsPolicyStatusAvailable: "לא פעילה",
    robotSmsPolicyFile: "קובץ",
    robotSmsPolicyOpen: "פתיחת PDF",
    robotSmsPolicyUploaded: "הועלתה",
    robotSmsPolicyActivatedAt: "פעילה מאז",
    robotSmsPolicyAccepted: "אושרה על ידי",
    robotSmsPolicyActions: "פעולות",
    robotSmsPolicyMakeActive: "הפוך לפעילה",
    robotSmsPolicyDisable: "השבתה",
    robotSmsPolicyEnable: "הפעלה מחדש",
    robotSmsPolicyActiveCantDisable: "אי אפשר להשבית את הגרסה הפעילה - יש להפוך גרסה אחרת לפעילה קודם",
    robotSmsPolicyActivateConfirm:
      "להפוך את גרסה {version} לפעילה? מפיקים שלא אישרו גרסה זו יצטרכו לקרוא ולאשר אותה לפני שימוש ברשימות שלהם.",
    robotSmsPolicyActivateSuccess: "גרסה {version} פעילה",
    robotSmsPolicyUpdateFailed: "עדכון הגרסה נכשל",
    robotSmsPolicyUploadTitle: "העלאת גרסה חדשה של המדיניות",
    robotSmsPolicyVersionLabel: "גרסה, לדוגמה 1.1",
    robotSmsPolicyVersionInvalid: "אותיות, ספרות, \".\", \"-\" ו-\"_\" בלבד, עד 32 תווים",
    robotSmsPolicyVersionExists: "הגרסה הזו כבר קיימת",
    robotSmsPolicyDrop: "גררו לכאן את קובץ ה-PDF או לחצו לבחירה",
    robotSmsPolicyFileHint: "PDF בלבד, עד 20MB",
    robotSmsPolicyFileInvalid: "יש לבחור קובץ PDF עד 20MB",
    robotSmsPolicyUploadWarning:
      "הקובץ שיועלה יהפוך מיד לגרסה הפעילה. כל המפיקים יצטרכו לקרוא ולאשר אותו מחדש לפני שימוש ברשימות שלהם.",
    robotSmsPolicyUploadSubmit: "העלאה והפעלה",
    robotSmsPolicyUploadSuccess: "גרסה {version} הועלתה והיא פעילה",
    robotSmsPolicyUploadFailed: "העלאת הקובץ נכשלה",
    robotSmsPolicyTabVersions: "גרסאות המסמך",
    robotSmsPolicyTabDeclarations: "הצהרות חתומות",
    robotSmsAutoApprove: "אישור אוטומטי של הצהרות",
    robotSmsAutoApproveOnHint: "מופעל: מפיקים יכולים להעלות רשימות מיד אחרי החתימה. כבו כדי לאשר כל הצהרה ידנית.",
    robotSmsAutoApproveOffHint: "כבוי: כל הצהרה חתומה ממתינה לאישור שלכם. המפיק מקבל התראה על ההחלטה.",
    robotSmsAutoApproveOn: "אישור אוטומטי הופעל",
    robotSmsAutoApproveOff: "אישור אוטומטי כבוי - הצהרות חדשות ממתינות לאישור",
    robotSmsDeclarationStatusAll: "הכול",
    robotSmsDeclarationStatus_pending: "ממתינה לבדיקה",
    robotSmsDeclarationStatus_approved: "אושרה",
    robotSmsDeclarationStatus_rejected: "נדחתה",
    robotSmsDeclarationStatus_revoked: "הגישה בוטלה",
    robotSmsDeclarationSearch: "חיפוש לפי שם, ת.ז., עסק, אימייל או טלפון",
    robotSmsDeclarationSignedAt: "נחתמה",
    robotSmsDeclarant: "המצהיר",
    robotSmsDeclarationBusiness: "עסק",
    robotSmsDeclarationContacts: "פרטי קשר",
    robotSmsDeclarationReview: "לבדיקה",
    robotSmsDeclarationOpen: "פתיחה",
    robotSmsDeclarationTitle: "הצהרה חתומה",
    robotSmsDeclarationIdNumber: "מספר תעודת זהות",
    robotSmsDeclarationRegistrationNumber: "ח.פ. / ע.מ.",
    robotSmsDeclarationDataSource: "מקור הנתונים",
    robotSmsDeclarationAccount: "חשבון בסלקטור",
    robotSmsDeclarationReviewed: "נבדקה",
    robotSmsDeclarationAuto: "אוטומטית",
    robotSmsDeclarationReason: "סיבה: {reason}",
    robotSmsDeclarationIdPhoto: "צילום תעודה מזהה",
    robotSmsDeclarationSignature: "חתימה",
    robotSmsDeclarationOpenFile: "פתיחת הקובץ",
    robotSmsDeclarationLinksHint: "הקבצים פרטיים. הקישורים פעילים 10 דקות - פתחו את ההצהרה שוב כדי לקבל קישורים חדשים.",
    robotSmsDeclarationReasonLabel: "סיבה",
    robotSmsDeclarationReasonHint: "המפיק יראה את הטקסט הזה",
    robotSmsDeclarationClose: "סגירה",
    robotSmsDeclarationRestore: "החזרת הגישה",
    robotSmsDeclarationAction_approve: "אישור",
    robotSmsDeclarationAction_reject: "דחייה",
    robotSmsDeclarationAction_revoke: "ביטול הגישה",
    robotSmsDeclarationAction_approve_success: "אושרה - המפיק קיבל התראה",
    robotSmsDeclarationAction_reject_success: "נדחתה - המפיק קיבל התראה",
    robotSmsDeclarationAction_revoke_success: "הגישה בוטלה - המפיק קיבל התראה",

    //DEVICES MODAL
    devicesModalTitle: "מכשירים פעילים",
    otpModalTitle: "הגדר משתמש OTP",
    robotCreditsModalTitle: "שנה נקודות SMS לרובוט משתמש",
    devicesModalActionDisconnectSuccess: "ניתוק המכשיר הצליח",
    devicesModalActionDisconnectFailure: "שגיאת ניתוק מכשיר",

    //ADD PAYMENT MODAL
    apModalTitle: "הוסף תשלום חדש",
    apModalDropFileHere: "שחרר את הקובץ כאן",
    apModalDragFileHere: "גרור את הקובץ לכאן",
    apModalUploadFile: "העלה קובץ",
    apModalReUploadFile: "העלה מחדש את הקובץ",

    //FILTER
    filterTitle: "לסנן",
    filterItemOnlyPaid: "אירועים ששולמו",
    filterItemSortByName: "מיין לפי שם",
    filterItemAscending: "עולה",
    filterSubmit: "שלח",
    filterRestore: "לשחזר",
    filterSearch: "לחפש",
    filterSearchEventsHint: "חיפוש: שם, id:123, link:abc",
    filterSearchUsersHint: "חיפוש: שם/משפחה, טלפון, id:123",
    filterSearchOrganizersHint: "חיפוש: שם/משפחה, טלפון, id:123",

    //CUSTOM DATE RANGE PICKER
    cdrpFrom: "מ...",
    cdrpTo: "ל...",

    //CUSTOM DATAGRID
    customDataGridLoadMore: "טען עוד",

    // EVENTS STATUS NAV
    esnWaitingForConfirm: "מחכה לאישור",
    esnDeletedEvents: "שנמחקו",
    esnFinishedEvents: "שהסתיימו",
    esnFinishedUnpaidEvents: "ללא תשלום",
    esnHiddenEvents: "נסתרים",
    esnAllEvents: "כל האירועים",
    esnActiveEvents: "פעילים",
    esnCanceledEvents: "שבוטלו",
    esnInProgressEvents: "בתהליך",
    esnCurrentWeekEvents: "השבוע הנוכחי",

    //#region PROFILES
    gridProfilesTotalClearances: "סך סליקה כולל",
    gridProfilesTotalPurchases: "סך כל הרכישות",
    gridProfilesAmountOfPurchasedTickets: "כמות הכרטיסים שנרכשו",
    gridProfilesAmountOfEvents: "כמות אירועים",
    gridProfilesProducerAndIdentityCardOrHPAndPhoneNumber: "מידע מפיק",
    gridProfilesCreatorOfTheEvent: "יוצר האירוע",
    gridProfilesPostalCode: "מיקוד",
    gridProfilesCellphoneNumber: "מספר טלפון סלולארי",
    gridProfilesLinkToProfile: "קישור לפרופיל",
    gridProfilesDeletedUser: "משתמש שנמחק",
    gridProfilesChangeRobotSmsCredits: "שנה קרדיט SMS רובוט",
    gridProfilesChangeRobotSmsCreditsCount: "קרדיט SMS רובוט:",
    gridProfilesChangeRobotSmsAccess: "רובוט עדכונים",
    gridProfilesRestoreUser: "שחזר משתמש",
    gridProfilesAutoConfirmationUser: "אישור אוטומטי",

    buttonDownloadAllInformation: "הורד את כל המידע",
    profilesDeletedProfiles: "פרופילים שנמחקו",
    profilesAllProfiles: "כל הפרופילים",
    profilesTotalCreditsCountL: 'רובוט SMS סה"כ קרדיטים:',
    //#endregion

    //ALL EVENTS
    gridEventsOpenAsOwner: "פתוח כבעלים",
    gridEventsPaymentStatus: "סטטוס תשלום",
    gridEventsPaymentStatusIsPaidCheckBox: "שולם",
    gridEventsOrderConfirmation: "אישור תשלום",
    gridEventsFile: "קובץ",
    gridEventsReceiptFile: "קובץ קבלות",
    gridEventsInvoiceFile: "קובץ חשבונית",
    gridEventsBankAccountInfo: "פרטי חשבון בנק",
    gridEventsBankAccountInfoNumber: "מס' בנק",
    gridEventsBankAccountInfoAccountNumber: "מס חשבון",
    gridEventsBankAccountFullName: "שם מלא",
    gridEventsTotalCommisionProfit: 'סה"כ רווח עמלה',
    gridEventsTotalTicketsPurchasedInCredit: "סך הכל כסף ללא עמלה",
    gridEventsTotalTicketsSold: 'סה"כ כרטיסים שנמכרו',
    gridEventsTotalTicketsSoldInCredit: "כרטיסים שנמכרו באשראי",
    gridEventsCanceledMoney: "כמות כסף שהוחזרה עקב בקשות ביטול",
    gridEventsCanceledCount: "כמות כרטיסים עם בקשת החזר",
    gridEventsReturnedMoney: "כסף שהוחזר",
    gridEventsReturnedCount: "כמות כרטיסים שבוטלו",
    gridEventsProducerAndIdentityCardOrHPAndPhoneNumber: "פרטי הפרופיל",
    gridEventsCreatorName: "היוצר של האירוע",
    gridEventsCreatorAddress: "מיקוד",
    gridEventsCreatorPhone: "מספר טלפון סלולארי",
    gridEventsStartDate: "תאריך האירוע",
    gridEventsCreateDate: "תאריך תחילת המכירה",
    gridEventsName: "שם האירוע",
    gridEventsStatus: "מצב האירוע",
    gridEventsStatusDeleted: "אירוע שנמחק",
    gridEventsStatusHidden: "אירוע נסתר",
    gridEventsStatusHighPriority: "עדיפות גבוהה",
    gridEventsRepeatEvent: "חזור על אירוע",
    gridEventsShowEvent: "הצג אירוע",
    gridEventsConfirmEvent: "אשר את האירוע",
    gridEventsDeleteEvent: "מחק אירוע",

    //TRANSACTIONS
    invoiceTotalInvoicesBeforeVAT: 'סך החשבוניות לפני מע"מ',
    invoiceTotalVAT: 'סך המע"מ',
    invoiceTotalInvoicesIncluded: "סך כל החשבוניות כלולות",
    invoiceThisEventHasNoSuchFiles: "לאירוע הזה אין קבצים כאלה",
    transactionsInvoices: "חשבוניות",
    transactionsConfirm: "אישורים",
    transactionsCancelled: "מבוטל",
    transactionsFetchError: "אירעה שגיאה בעת טעינת הדף",

    //LOGIN
    loginEnterNumber: "הזן את מספר הטלפון שלך כאן",
    loginSendCode: "שלח קוד באמצעות SMS",
    loginEnterCode: "הזן את קוד ההסכמה שלך כאן",
    loginVerifyCode: "אמת קוד OTP",
    loginCodeSendSuccess: "OTP נשלח בהצלחה",
    loginCodeInvalid: "קוד לא תקין",
    loginError: "שגיאה",

    organizersAllOrganizers: "כולם",
    organizersActiveOrganizers: "פעילים",
    organizersNotActiveOrganizers: "לא פעילים",

    organizersTotalCount: "סה״כ מארגנים:",
    organizersButtonDownloadExcel: "הורד אקסל",
    organizersButtonDownloadShortExcel: "הורד מידע קצר",

    gridOrganizersOrganizerInfo: "פרטי מארגן",
    gridOrganizersName: "שם מלא:",
    gridOrganizersPhone: "טלפון:",
    gridOrganizersEmail: "אימייל:",
    gridOrganizersIDcode: "תעודת זהות:",

    gridOrganizersOrganizerEventsInfo: "פרטי אירועים",
    gridOrganizersTotalEventsCount: "סה״כ אירועים:",
    gridOrganizersActiveEventsCount: "אירועים פעילים:",
    gridOrganizersFinishedEventsCount: "אירועים שהסתיימו:",
    gridOrganizersCancelledEventsCount: "אירועים שבוטלו:",
    gridOrganizersPendingEventsCount: "אירועים ממתינים:",

    gridOrganizersOrganizerEventsActivityInfo: "מידע על פעילות האירועים",
    gridOrganizersTotalTicketsSoldCount: "סה״כ כרטיסים:",
    gridOrganizersTotalTicketsSoldMoney: "סה״כ כסף מכרטיסים:",
    gridOrganizersTotalTicketsSoldFee: "סה״כ עמלות מכרטיסים:",
    gridOrganizersActivePeriodTotalTicketsSoldCount:
      "כרטיסים שנמכרו ב-60 הימים האחרונים:",
    gridOrganizersActivePeriodTotalTicketsSoldMoney:
      "כסף מכרטיסים ב-60 הימים האחרונים:",
    gridOrganizersActivePeriodTotalTicketsSoldFee: "עמלות ב-60 הימים האחרונים:",

    gridOrganizersOrganizerActivityInfo: "מידע על פעילות",
    gridOrganizersJoinDate: "תאריך הצטרפות:",
    gridOrganizersLastEventDate: "תאריך האירוע האחרון:",
    gridOrganizersStatus: "סטטוס:",
    gridOrganizersStatusActive: "פעיל 😊",
    gridOrganizersStatusNotActive: "לא פעיל 🤔",

    gridOrganizersSettings: "הגדרות",
    gridOrganizersChangeRobotSmsCreditsCount: "יתרת SMS רובוטי:",
    gridOrganizersChangeRobotSmsCredits: "שנה יתרת SMS רובוטי",
    gridOrganizersChangeRobotSmsAccess: "גישה ל-SMS רובוטי",
    gridOrganizersAutoConfirmationUser: "אישור אוטומטי",
    gridOrganizersHideEventsFromMain: "הסתרת אירועים מהעמוד הראשי",

    // Other
    changeUserCredits: "עדכן את קרדיט ה-SMS של רובוט המשתמש",
    updateCreditsError: "שגיאה. נסה שוב בבקשה.",

    onlyUnpaidEventsFlagText: "להוציא דו\"ח של אירועים ללא תשלום",
    downloadReportModalTitle: "להוריד דו״ח אירועים",
    ignoreYeshInvoiceText: "התעלם YeshInvoice",
    ignoreTransactionsText: "התעלם מעסקאות",
    ignoreZCreditText: "התעלם ZCredit",
    downloadReportFromDate: "מתאריך",
    downloadReportToDate: "עד תאריך",
    downloadReport: 'הורדת דו"ח',
    downloadReportError: "אירעה שגיאה בהורדת הדו״ח",

    cancelTicketModalTitle: "ביטול כרטיס",
    phoneNumberPlaceholder: "מספר טלפון",
    eventLinkPlaceholder: "קישור לאירוע",
    searchTickets: "חיפוש כרטיסים",
    backToSearch: "חזרה לחיפוש",
    buyerUser: "רוכש הכרטיס",
    ticketUser: "משתמש הכרטיס",
    ticketInfo: "פרטי הכרטיס",
    price: "מחיר",
    feePrice: "עמלה",
    cardHolder: "שם בעל הכרטיס",
    cardNumber: "מספר כרטיס",
    ticketStatus: "שינוי סטטוס כרטיס",
    returnMoney: "החזר כספי (ZCredit)",
    sendSms: "שלח SMS",
    yeshInvoiceDocs: "צור מסמכים ל־ (YeshInvoice)",
    fullReturn: "החזר כספי מלא (כולל עמלה)",
    changeTicketStatus: "שנה סטטוס כרטיסים",
    backToList: "חזרה לרשימה",
    ticketChangedSuccess: "סטטוס הכרטיסים עודכן בהצלחה",
    cancelTicketByUuidModalTitle: "ביטול כרטיס לפי UUID",
    sessionIdPlaceholder: "מזהה סשן (UUID)",
    cancelTicketByUuidSubmit: "בטל כרטיסים",
    continue: "המשך",
    existDocumentSkip: "דלג על בדיקת מסמך קיים (אפשר הפעלה חוזרת)",

    organizerSettingsAdminNote: "הערת מנהל לגבי המארגן",
    organizerSettingsModalTitle: "עדכון הגדרות מארגן",
    organizerFreeTransactionCount: "מספר עסקאות חינם",
    organizerTransactionFee: "עמלת עסקה",
    organizerFastWithdrawalFee: "עמלת משיכה מהירה",
    organizerTransactionMinSum: "סכום מינימום לעסקה",
    organizerEarlyWithdrawalEnabled: "משיכה מוקדמת",
    organizerEarlyWithdrawalPercent: "אחוז משיכה מוקדמת",
    organizerEarlyWithdrawalDays: "ימי משיכה מוקדמת",
    organizerEarlyWithdrawalFee: "עמלת משיכה מוקדמת",
    organizerWithdrawalTypeDefault: "ברירת מחדל",
    organizerWithdrawalTypeDays: "לפי ימים",
    organizerWithdrawalDays: "ימי משיכה",
    organizerUpdateSettings: "עדכן הגדרות",
    organizerFreeTransactionCountMinError: "מספר מינימום לעסקאות חינם הוא 0",
    organizerFreeTransactionCountRequiredError: "חובה להזין מספר עסקאות חינם",
    organizerTransactionFeeMinError: "עמלת עסקה מינימלית היא 0",
    organizerTransactionFeeRequiredError: "חובה להזין עמלת עסקה",
    organizerFastWithdrawalFeeMinError:
      "העמלה למשיכה מהירה חייבת להיות לפחות 0",
    organizerFastWithdrawalFeeRequiredError: "נדרשת עמלה למשיכה מהירה",
    organizerTransactionMinSumMinError: "סכום מינימום לעסקה הוא 0",
    organizerTransactionMinSumRequiredError: "חובה להזין סכום מינימום לעסקה",
    organizerEarlyWithdrawalPercentMinError: "אחוז מינימום לעסקה הוא 0",
    organizerEarlyWithdrawalPercentMaxError: "אחוז מקסימום לעסקה הוא 100",
    organizerEarlyWithdrawalPercentRequiredError:
      "חובה להזין אחוז משיכה מוקדמת",
    organizerEarlyWithdrawalDaysMinError:
      "מספר ימים מינימלי למשיכה מוקדמת הוא ‎-365",
    organizerEarlyWithdrawalDaysMaxError:
      "מספר ימים מקסימלי למשיכה מוקדמת הוא 365",
    organizerEarlyWithdrawalDaysRequiredError:
      "חובה להזין מספר ימים למשיכה מוקדמת",
    organizerEarlyWithdrawalFeeMinError:
      "אחוז מינימום לעמלת משיכה מוקדמת הוא 0",
    organizerEarlyWithdrawalFeeMaxError:
      "אחוז מקסימום לעמלת משיכה מוקדמת הוא 100",
    organizerEarlyWithdrawalFeeRequiredError: "חובה להזין עמלת משיכה מוקדמת",
    organizerWithdrawalDaysMinError: "מספר ימים מינימלי למשיכה הוא 0",
    organizerWithdrawalDaysRequiredError: "חובה להזין מספר ימים למשיכה",

    transactionAll: "הכל",
    transactionPending: "ממתין",
    transactionWithdrawn: "נמשך",
    transactionRejected: "נדחה",
    transactionCancelled: "בוטל",
    transactionInProgress: "בביצוע",
    transactionFast: "מהיר",

    showTransactions: "הצג עסקאות",

    gridEventTransactionListTransactionNameInfo: "מידע כללי",
    gridEventTransactionListTransactionName: "שם העסקה",
    gridEventTransactionListTransactionDescription: "הערת עסקה",
    gridEventTransactionListTransactionAdminDescription: "הערת מנהל לעסקה",
    gridEventTransactionListTransactionAdminComment: "תגובת מנהל",
    gridEventTransactionListAddAdminComment: "הוסף תגובה",
    gridEventTransactionListEditAdminComment: "ערוך תגובה",
    gridEventTransactionListDeleteAdminComment: "מחק תגובה",
    adminCommentPlaceholder: "כתוב את התגובה שלך",
    adminCommentEmptyError: "התגובה לא יכולה להיות ריקה",
    adminCommentVisibilityHint: "תגובה זו גלויה רק למנהלים בפאנל הניהול.",
    saveAdminComment: "שמור",
    gridEventTransactionListAddAdminNote: "הוסף הערת מנהל",
    gridEventTransactionListEditAdminNote: "ערוך הערת מנהל",
    gridEventTransactionListDeleteAdminNote: "מחק הערת מנהל",
    adminNoteEmptyError: "הערת המנהל לא יכולה להיות ריקה",
    adminNoteVisibilityHint: "הערת מנהל זו מוצגת למארגן ונכללת במסמך ה-PDF.",
    saveAdminNote: "שמור",

    gridEventTransactionListEventInfo: "מידע על האירוע",
    gridEventTransactionListEventName: "שם האירוע",
    gridEventTransactionListEventStartDate: "תאריך התחלת האירוע",
    gridEventTransactionListEventEndDate: "תאריך סיום האירוע",
    gridEventTransactionListEventShowInfo: "הצג מידע",

    gridEventTransactionListOrganizerInfo: "מידע על המארגן",
    gridEventTransactionListOrganizerName: "שם מלא",
    gridEventTransactionListOrganizerPhone: "טלפון",
    gridEventTransactionListShowOrganizerInfo: "הצג מידע",

    gridEventTransactionListTransactionInfo: "מידע על העסקה",
    gridEventTransactionListItemLastTransaction: "עסקת אירוע אחרונה",
    gridEventTransactionListItemFastWithdrawal: "משיכה מהירה",
    gridEventTransactionListItemEarlyWithdrawal: "משיכה מוקדמת",
    gridEventTransactionListItemTotal: "סכום כולל",
    gridEventTransactionListItemAmount: "סכום משיכה",
    gridEventTransactionListItemFee: "עמלת עסקה",
    gridEventTransactionListItemEarlyFee: "עמלת משיכה מוקדמת",
    gridEventTransactionListItemFastFee: "עמלת משיכה מהירה",

    gridEventTransactionListBillAccountInfo: "פרטי חשבון בנק",
    gridEventTransactionListBillAccountName: "שם",
    gridEventTransactionListBillAccountDescription: "תיאור",
    gridEventTransactionListBillAccountHolderName: "שם בעל החשבון",
    gridEventTransactionListBillAccountBankName: "שם הבנק",
    gridEventTransactionListBillAccountBankNumber: "מספר הבנק",
    gridEventTransactionListBillAccountBankAccountNumber: "מספר חשבון בנק",
    gridEventTransactionListBillAccountIdCode: "קוד זיהוי",

    gridEventTransactionListTransactionDates: "תאריכי העסקה",
    gridEventTransactionListRequestDate: "תאריך בקשה",
    gridEventTransactionListLastChangeDate: "תאריך שינוי אחרון",
    gridEventTransactionListStatus: "סטטוס",
    gridEventTransactionListStatusWithdrawn: "נמשך",
    gridEventTransactionListStatusPending: "ממתין",
    gridEventTransactionListStatusRejected: "נדחה",
    gridEventTransactionListStatusCancelled: "בוטל",

    gridEventTransactionListActions: "פעולות",
    gridEventTransactionListMoveToInProgressTransaction: "העבר לבביצוע",
    gridEventTransactionListInProgress: "העסקה בביצוע",
    gridEventTransactionListApproveTransaction: "אישור עסקה",
    gridEventTransactionListDeclineTransaction: "דחיית עסקה",
    gridEventTransactionListDownloadTransactionReceiptPdf:
      "הורד מסמך משיכה ב-PDF",
    gridEventTransactionListDownloadTransactionFeePdf: "הורד קובץ PDF של העמלה",
    gridEventTransactionListDownloadTransactionEarlyWithdrawalFeePdf:
      "הורד קובץ PDF של עמלת משיכה מוקדמת",
    gridEventTransactionListDownloadTransactionFastWithdrawalFeePdf:
      "הורד קובץ PDF של עמלת המשיכה המהירה",

    gridOrganizerRequestListRequestInfo: "מידע על הבקשה",
    gridOrganizerRequestListRequestMessage: "הודעת בקשה",
    gridOrganizerRequestListRequestDate: "תאריך בקשה",
    gridOrganizerRequestListActions: "פעולות",
    gridOrganizerRequestListApproveRequest: "אישור בקשה",
    gridOrganizerRequestListDeclineRequest: "דחיית בקשה",

    approveTransaction: "אשר עסקה",
    declineTransaction: "דחה עסקה",
    adminNotePlaceholder: "השאר הערת מנהל",
    approveRequest: "אשר בקשה",
    declineRequest: "דחה בקשה",
    cancel: "ביטול",

    gridEventsCrossQRScanner: "הצג הגדרות QR",
    eventCrossQRScannerModalTitle: "עדכון הגדרות סורק QR חוצה אירועים",
    relatedEventLink: "קישור לאירוע קשור",
    addRelatedScannerEvent: "הוסף עוד אחד",
    updateRelatedScannerEvent: "עדכן הגדרות סורק QR של האירוע",
    relatedEventLinkRequiredError: "נדרש קישור לאירוע קשור",
    relatedEventsSuccessUpdated: "האירועים הקשורים עודכנו בהצלחה",

    usersRequiredError: "שדה חובה",
    usersFormatError:
      "כל שורה חייבת להיות בפורמט: phone,name,surname[,count[,IDcode]]",
    usersColumnsCountError: "שורה {n}: הציפייה לפורמט טלפון,שם,שם משפחה",
    usersPhoneRequiredError: "שורה {n}: נדרש מספר טלפון",
    usersPhoneInvalidError: "שורה {n}: מספר טלפון לא תקין",
    usersNameRequiredError: "שורה {n}: נדרש שם פרטי",
    usersSurnameRequiredError: "שורה {n}: נדרש שם משפחה",
    usersCountInvalidError: "שורה {n}: count חייב להיות מספר שלם וחיובי",
    usersIdCodeInvalidError: "שורה {n}: ID code מכיל תווים לא חוקיים",
    smsRequiredError: "נדרש טקסט SMS",
    smsTextMustContainTicketLinkError: "טקסט ה-SMS חייב לכלול %LINK_TO_TICKET%",

    giftNoneOption: "לא נבחר",
    gridEventsGiftTickets: "כרטיסי מתנה",
    ticketsSuccessGifted: "הכרטיס הוענק בהצלחה",
    eventGiftTicketsModalTitle: "הענקת כרטיסים",
    giftUsersHelper: "פורמט שורה: טלפון,שם,שם משפחה,כמות,קוד זיהוי",
    giftUsers: "משתמשים להענקה",
    giftSmsTextHelper:
      "לטקסט ה-SMS חובה לכלול את המשתנה %LINK_TO_TICKET% ואפשרי להוסיף %EVENT_NAME%",
    giftSmsText: "טקסט SMS",
    giftTicketHelper:
      'ניתן לבחור כרטיס קיים או להוסיף שם (כרטיס ייווצר אוטומטית לרשימת המשתמשים), שם ברירת מחדל "כרטיס מתנה לאירוע"',
    giftTicketSelect: "בחר כרטיס (אופציונלי)",
    giftTicketName: "שם כרטיס (אופציונלי)",
    giftTickets: "כרטיסי מתנה",

    changeEventStatusLabel: "שנה סטטוס",
    changeEventStatusSuccess: "סטטוס האירוע שונה",
    changeEventStatusError: "אירעה שגיאה בשינוי סטטוס האירוע",
    gridEventsSettings: "הגדרות",
    eventSettingsModalTitle: "הגדרות אירוע",
    eventSettingsSectionStatus: "סטטוס האירוע",
    eventSettingsSectionBaseLink: "קישור ברירת מחדל",
    eventSettingsBaseLinkHelper: "אותיות, ספרות ו־'_' ו־'-' בלבד. חייב להיות ייחודי בין כל האירועים.",
    eventSettingsBaseLinkTakenError: "הקישור כבר בשימוש",
    eventSettingsBaseLinkInvalidError: "פורמט קישור לא חוקי",
    eventSettingsBaseLinkAvailable: "הקישור זמין",
    eventSettingsLinksInfo: "כל הקישורים שפותחים את האירוע. לאחר שינוי קישור, הכתובת הישנה ממשיכה לעבוד — קישורים שכבר הופצו (SMS, פרסום, רשתות חברתיות) עדיין פותחים את האירוע. הסר קישור ישן כדי לבטל אותו או לפנות אותו לאירוע אחר.",
    eventSettingsLinkPrevious: "קישורים ישנים שעדיין פעילים:",
    eventSettingsLinkPreviousDeleteConfirm: "להסיר את הקישור הישן? הוא יפסיק לפתוח את האירוע.",
    eventSettingsLinkPreviousDeleted: "הקישור הישן הוסר",
    eventSettingsLinksEmpty: "לאירוע זה אין קישורים",
    eventSettingsLinksSearch: "חיפוש לפי קישור, שם או טלפון",
    eventSettingsLinkLabel: "קישור קצר",
    eventSettingsLinkSave: "שמור קישור",
    eventSettingsLinkSuccess: "קישור עודכן",
    eventSettingsLinkOther: "קישור נוסף",
    eventSettingsLinkReferral: "קישור הפניה",
    eventSettingsLinkPersonal: "קישור אישי",
    eventSettingsLinkDeleted: "נמחק",
    eventSettingsTabCommon: "כללי",
    eventSettingsTabLinks: "קישורים לאירוע",
    eventSettingsTabOwner: "החלף בעלים",
    eventSettingsSaveStatus: "שמור סטטוס",

    headerManageEventTypes: "סוגי אירועים",
    eventTypesModalTitle: "סוגי אירועים",
    eventTypesTabAll: "הכל",
    eventTypesTabDashboard: "דשבורד",
    eventTypesTranslationEn: "כותרת (EN)",
    eventTypesTranslationHe: "כותרת (HE)",
    eventTypesShowInDashboard: "דשבורד",
    eventTypesOrder: "סדר",
    eventTypesDashboardOrder: "סדר בדשבורד",
    eventTypesApply: "החל",
    eventTypesApplySuccess: "סוגי אירועים עודכנו",
    eventTypesApplyError: "אירעה שגיאה בעדכון סוגי אירועים",
    eventTypesOtpSent: "OTP נשלח לטלגרם שלך",
    eventTypesOtpModalTitle: "אישור שינויים",
    eventTypesOtpModalDescription: "הזן את קוד ה־OTP שנשלח לטלגרם כדי להחיל את השינויים",
    eventTypesOtpConfirm: "אישור",
    eventTypesOtpResend: "שלח OTP מחדש",
    eventTypesTabDeleted: "נמחקו",
    eventTypesAdd: "הוסף סוג",
    eventTypesNew: "חדש",
    eventTypesDelete: "מחק",
    eventTypesRestore: "שחזר",
    eventTypesDeleteConfirm: "למחוק את סוג האירוע? הוא ייעלם מיצירת אירוע, מהסינון, מהדשבורד ומהבאנר. אירועים קיימים ימשיכו להציג אותו.",
    eventTypesDeletedEmpty: "אין סוגי אירועים שנמחקו",
    eventTypesTitleRequiredError: "יש להזין כותרת באנגלית ובעברית",
    eventTypesTitleEnLatinError: "הכותרת באנגלית חייבת להכיל אותיות לטיניות או ספרות",
    eventTypesDuplicateError: "סוג אירוע עם כותרת זו כבר קיים",
    eventTypesDuplicateDeletedError: "סוג אירוע זה נמצא ברשימת הנמחקים. יש לשחזר אותו במקום ליצור חדש",
    eventsScreenChangeOwnerByLink: "שנה בעלים לפי לינק",
    changeOwnerByLinkModalTitle: "שינוי בעלי האירוע לפי לינק",
    changeOwnerByLinkFieldLabel: "לינק לאירוע, כתובת URL או מזהה אירוע",
    changeOwnerByLinkFieldHelper: "הדבק לינק קצר (11 תווים), כתובת URL של אירוע או מזהה אירוע מספרי",
    changeOwnerByLinkFieldRequiredError: "יש להזין לינק לאירוע",
    changeOwnerByLinkFieldInvalidFormatError: "יש להזין מזהה אירוע חוקי, לינק קצר או כתובת URL של אירוע",
    changeOwnerByLinkFieldInvalidIdError: "מזהה האירוע חייב להיות מספר חיובי",
    changeOwnerByLinkLookup: "חפש אירוע",
    changeOwnerByLinkNotFound: "אירוע לא נמצא לפי הלינק",
    changeEventOwnerModalTitle: "שינוי בעלי האירוע",
    changeEventOwnerCurrentOwner: "בעלים נוכחי",
    changeEventOwnerSearchLabel: "חיפוש בעלים חדש",
    changeEventOwnerSearchHelper: "שם / שם משפחה / טלפון. לחיפוש לפי מזהה השתמש ב־id:123",
    changeEventOwnerNewOwner: "בעלים חדש",
    changeEventOwnerNoOwnerSelected: "בחר בעלים חדש",
    changeEventOwnerKeepOldOwner: "השאר את הבעלים הנוכחי כעורך עם הרשאות של בעלים",
    changeEventOwnerSendOtp: "שלח OTP",
    changeEventOwnerResendOtp: "שלח OTP מחדש",
    changeEventOwnerConfirm: "אישור שינוי",
    changeEventOwnerOtpSent: "OTP נשלח לטלגרם שלך",
    changeEventOwnerOtpLabel: "קוד OTP",
    changeEventOwnerSuccess: "בעלי האירוע שונו",
    changeEventOwnerError: "אירעה שגיאה בשינוי בעלי האירוע",
    changeEventOwnerConfirmModalTitle: "אישור שינוי בעלים",
    changeEventOwnerConfirmModalDescription: "הזן את קוד ה־OTP שנשלח לטלגרם כדי לאשר את שינוי הבעלים",
    confirmActionOtpConfirm: "אישור",
    confirmActionOtpResend: "שלח OTP מחדש",

    sendPushNotificationTitle: "התראות פוש",
    sendPushNotificationTabCustom: "התראה מותאמת",
    sendPushNotificationTabDocs: "עדכון מסמכים",
    sendPushNotificationCustomHelper: "ניתן להשתמש ב־%USER_NAME% בתוך הטקסט — הוא יוחלף בשם המלא של הנמען.",
    sendPushNotificationDocsHelper: "הטקסט נטען מהשרת ונשלח כפי שהוא בשפת הנמען.",
    sendPushNotificationTitleEn: "כותרת (EN)",
    sendPushNotificationTitleHe: "כותרת (HE)",
    sendPushNotificationTextEn: "טקסט (EN)",
    sendPushNotificationTextHe: "טקסט (HE)",
    sendPushNotificationAudience: "קהל יעד",
    sendPushNotificationAudience_allOrganizers: "כל המפיקים",
    sendPushNotificationAudience_activeOrganizers: "מפיקים פעילים",
    sendPushNotificationAudience_notActiveOrganizers: "מפיקים לא פעילים",
    sendPushNotificationAudience_allUsers: "כל המשתמשים",
    sendPushNotificationTestCheckbox: "שליחת התראת בדיקה (למשתמש בודד לפי טלפון)",
    sendPushNotificationTestPhoneLabel: "טלפון הנמען",
    sendPushNotificationTestPhoneRequired: "יש להזין את טלפון הנמען",
    sendPushNotificationTestUserNameLabel: "שם משתמש לבדיקה",
    sendPushNotificationTestUserNameHelper: "ישמש להחלפת %USER_NAME% בהודעת הבדיקה",
    sendPushNotificationTestUserNameRequired: "יש להזין שם משתמש לבדיקה כאשר הטקסט משתמש ב־%USER_NAME%",
    sendPushNotificationValidationTitleTextRequired: "יש למלא כותרת וטקסט",
    sendPushNotificationSend: "שלח",
    sendPushNotificationSendTest: "שלח בדיקה",
    sendPushNotificationOtpSent: "קוד OTP נשלח לטלגרם",
    sendPushNotificationTestSuccess: "התראת בדיקה נשלחה",
    sendPushNotificationSendStarted: "שליחת ההתראות התחילה",
    sendPushNotificationOtpModalTitle: "אישור שליחת התראה",
    sendPushNotificationOtpModalDescription: "הזן את קוד ה־OTP שנשלח לטלגרם כדי לאשר את השליחה",

    sendSmsBroadcastTitle: "שליחת SMS",
    sendSmsTabOrganizers: "מפיקים",
    sendSmsIsraeliOnlyRemark: "ניתן לשלוח SMS למספרים ישראליים בלבד (+972)",
    sendSmsIsraeliOnly: "ניתן לשלוח SMS למספרים ישראליים בלבד (+972)",
    sendSmsHelperFreeText: "טקסט חופשי — כתוב באנגלית ו/או בעברית. כל נמען יקבל את הגרסה בשפה שלו.",
    sendSmsHelperUserName: "טיפ: ניתן להשתמש ב-%USER_NAME% בטקסט כדי להתאים אישית את ה-SMS — הוא יוחלף בשם של כל נמען.",
    sendSmsTextEn: "טקסט (EN)",
    sendSmsTextHe: "טקסט (HE)",
    sendSmsAudience: "קהל יעד",
    sendSmsAudience_allOrganizers: "כל המפיקים",
    sendSmsAudience_activeOrganizers: "מפיקים פעילים",
    sendSmsAudience_notActiveOrganizers: "מפיקים לא פעילים",
    sendSmsTestCheckbox: "שליחת SMS לבדיקה (למשתמש בודד לפי טלפון)",
    sendSmsTestPhoneLabel: "טלפון הנמען (+972 בלבד)",
    sendSmsTestPhoneRequired: "יש להזין טלפון נמען",
    sendSmsTestUserNameLabel: "שם משתמש לבדיקה",
    sendSmsTestUserNameHelper: "ישמש להחלפת %USER_NAME% בהודעת הבדיקה",
    sendSmsTestUserNameRequired: "יש להזין שם משתמש לבדיקה כאשר הטקסט משתמש ב־%USER_NAME%",
    sendSmsValidationTextRequired: "יש להזין טקסט להודעה",
    sendSmsSend: "שלח SMS",
    sendSmsSendTest: "שלח SMS לבדיקה",
    sendSmsOtpSent: "קוד OTP נשלח לטלגרם",
    sendSmsTestSuccess: "SMS לבדיקה נשלח",
    sendSmsBroadcastStarted: "שליחת ה־SMS התחילה",
    sendSmsOtpModalTitle: "אישור שליחת SMS",
    sendSmsOtpModalDescription: "הזן את קוד ה־OTP שנשלח לטלגרם כדי לאשר את השליחה",

    eventSettingsTabSms: "SMS",
    eventSmsTabDescription: "שליחת SMS הקשור לאירוע זה. כל פעולה דורשת אישור באמצעות OTP.",
    eventSmsIsraeliOnlyRemark: "ניתן לשלוח SMS למספרים ישראליים בלבד (+972)",
    eventSmsKind_resendBuyers_title: "שלח שוב SMS לרוכשי כרטיסים",
    eventSmsKind_resendBuyers_description: "שולח שוב את SMS האישור (כרטיסים + קבלה) לכל מי שרכש כרטיס.",
    eventSmsKind_resendBuyers_tooltip: "עובר על כל רוכשי הכרטיסים המאושרים ושולח מחדש את SMS האישור הרגיל. אין צורך בטקסט מותאם.",
    eventSmsKind_notifyHolders_title: "שלח SMS למחזיקי כרטיסים",
    eventSmsKind_notifyHolders_description: "שולח SMS תזכורת לכל מי שמחזיק כרטיס (עשוי להיות שונה מהרוכש בכרטיסי מתנה).",
    eventSmsKind_notifyHolders_tooltip: "כולל את שם האירוע, התאריך וקישור לכרטיסים של הנמען.",
    eventSmsKind_customBuyers_title: "שלח SMS מותאם לרוכשי כרטיסים",
    eventSmsKind_customBuyers_description: "כתוב טקסט SMS משלך. המשתנים יוחלפו עבור כל נמען.",
    eventSmsKind_customBuyers_tooltip: "נשלח לרוכשי כרטיסים מאושרים. מספרים ישראליים בלבד.",
    eventSmsKind_customHolders_title: "שלח SMS מותאם למחזיקי כרטיסים",
    eventSmsKind_customHolders_description: "כתוב טקסט SMS משלך. המשתנים יוחלפו עבור כל נמען.",
    eventSmsKind_customHolders_tooltip: "נשלח למחזיקי הכרטיסים (ticketUser). מספרים ישראליים בלבד.",
    eventSmsVariablesHelp: "משתנים זמינים: %USER_NAME%, %EVENT_NAME%, %EVENT_DATE%, %LINK_TO_TICKET%",
    eventSmsTextEn: "טקסט SMS (EN)",
    eventSmsTextHe: "טקסט SMS (HE)",
    eventSmsSend: "שלח",
    eventSmsValidationTextRequired: "יש להזין טקסט להודעה מותאמת",
    eventSmsOtpSent: "קוד OTP נשלח לטלגרם",
    eventSmsBroadcastStarted: "שליחת ה־SMS של האירוע התחילה",
    eventSmsOtpModalTitle: "אישור שליחת SMS לאירוע",
    eventSmsOtpModalDescription: "הזן את קוד ה־OTP שנשלח לטלגרם כדי לאשר את השליחה",
    eventSmsTestCheckbox: "שליחת SMS לבדיקה (למספר טלפון בודד)",
    eventSmsTestPhoneLabel: "טלפון לבדיקה (+972 בלבד)",
    eventSmsTestPhoneRequired: "יש להזין טלפון לבדיקה",
    eventSmsIsraeliOnly: "ניתן לשלוח SMS למספרים ישראליים בלבד (+972)",
    eventSmsSendTest: "שלח בדיקה",
    eventSmsTestSuccess: "SMS לבדיקה נשלח",
    eventSmsTestUserNameLabel: "שם משתמש לבדיקה",
    eventSmsTestUserNameHelper: "ישמש להחלפת %USER_NAME% בהודעת הבדיקה",
    eventSmsTestUserNameRequired: "יש להזין שם משתמש לבדיקה כאשר הטקסט משתמש ב־%USER_NAME%",
    eventSmsTestDefaultsHelp: "במצב בדיקה %LINK_TO_TICKET% מוחלף ב־https://selector.org.il. %EVENT_NAME% ו־%EVENT_DATE% נלקחים מהאירוע הזה.",

    organizerEventFeeMinError: "אחוז דמי האירועים המינימלי הוא 0",
    organizerEventFeeMaxError: "אחוז דמי האירועים המקסימלי הוא 100",
    organizerEventFeeRequiredError: "נדרש להזין אחוז דמי אירועים",
    updateFeePercentError:
      "אירעה שגיאה בעת ניסיון לעדכן את דמי האירועים של המארגן",
    organizerSettingsEventFeePercentModalTitle: "דמי אירועים של המארגן",
    organizerEventFee: "דמי אירועים",
    organizerUpdateEventFeeSettings: "עדכון דמי אירועים",

    organizerFilesModalTitle: "קבצי מארגן",
    organizerFilesModalAddFile: "העלה קובץ חדש",

    uploadNewOrganizerFileModalTitle: "העלאת קובץ מארגן חדש",
    uploadNewOrganizerFileModalTitleDropOrClickFileHere:
      "לחץ או גרור קובץ לכאן",
    uploadNewOrganizerFileModalTitleDropFileHere: "לחץ או גרור קובץ לכאן",

    pdfFilePreview: "תצוגה מקדימה של קובץ PDF",

    createTransactionModalTitle: "יצירת עסקה חדשה עבור אירוע מארגן",
    selectOrganizerEvent: "בחירת אירוע של המארגן",
    eventNameSearchLabel: "חיפוש לפי שם האירוע",
    selectTransactionType: "בחירת סוג עסקה",
    transactionTypeService: "שירות",
    transactionTypeSimple: "עסקה",
    selectOrganizerBillAccount: "בחירת חשבון חיוב של המארגן",
    billAccountNameSearchLabel: "חיפוש לפי שם חשבון החיוב",
    successTransactionCreateMessage: "העסקה נוצרה בהצלחה",
    selectedEventName: "שם האירוע שנבחר:",
    totalEventAmount: "סכום כולל של האירוע",
    totalWithdrawnAmount: "סכום שנמשך בסך הכול",
    availableForWithdrawalAmount: "סכום זמין למשיכה",
    calculateData: "חישוב נתוני העסקה",
    totalTransactionAmount: "סכום כולל של העסקה",
    transactionAmount: "סכום העסקה",
    transactionFeeAmount: "סכום עמלת העסקה",
    fastWithdrawalFeeAmount: "סכום עמלת משיכה מהירה",
    warningOverdraftAmount: "עסקה זו תגרום לחריגה מהמסגרת!",
    overdraftAfterTransaction: "חריגה מהמסגרת לאחר יצירת העסקה",
    transactionAmountLabel: "סכום העסקה",
    transactionFeeAmountLabel: "סכום עמלת העסקה",
    transactionAdminWithdrawalFeeAmountLabel: "סכום עמלת משיכה אדמיניסטרטיבית",
    amountRequiredError: "יש להזין סכום",
    adminFeeRequiredError: "יש להזין סכום עמלת משיכה אדמיניסטרטיבית",
    numberMinError: "הערך חייב להיות גדול מ־0",
    transactionFastWithdrawalFeeAmountLabel: "סכום עמלת משיכה מהירה",
    transactionAdminNoteLabel: "הערת מנהל לעסקה",
    overdraftConfirmation: "אני מבין/ה שהעסקה תיווצר בחריגה מהמסגרת",
    transactionNameLabel: "שם העסקה",
    transactionNameRequiredError: "שם העסקה הוא שדה חובה",
    transactionNameMinError: "שם העסקה קצר מדי (מינימום 3 תווים)",
    formViewCreateButton: "יצירת עסקה",
    serviceFormViewCreateButton: "יצירת עסקת שירות",
    gridEventTransactionListItemAdminWithdrawal: "משיכה אדמיניסטרטיבית",
    gridEventTransactionListItemAdminFee: "עמלת משיכה אדמיניסטרטיבית",
    gridEventTransactionListItemOverdraft: "חריגה מהמסגרת 🚨",

    warningCancel: "הכסף מאירוע זה נמשך או נמצא בתהליך משיכה.",
    warningCancelCheckbox: "אני מבין/ה, בטל/י את הכרטיס(ים)",

    otherRecipientLabel: "ליצור חשבונית מס על שם אחר",
    recipientFullNameLabel: "שם מלא של המשתמש",
    recipientIdLabel: "תעודת זהות או מספר חברה",
    recipientPhoneLabel: "מספר טלפון של המשתמש",
    recipientEmailLabel: "אימייל משתמש",
    recipientFullNameRequiredError: "שם מלא של המשתמש הוא שדה חובה",
    recipientIdRequiredError: "תעודת זהות או מספר חברה הוא שדה חובה",
    phoneInvalidError: "מספר טלפון של המשתמש שגוי",
    phoneMinLengthError: "מספר טלפון של המשתמש שגוי",
    phoneMaxLengthError: "מספר טלפון של המשתמש שגוי",
    recipientPhoneRequiredError: "מספר טלפון של המשתמש הוא שדה חובה",
    emailInvalidError: "אימייל משתמש שגוי",
    recipientEmailRequiredError: "אימייל משתמש הוא שדה חובה",

    // MARKETING PERSONS
    marketingPersonsTitle: "אנשי שיווק",
    marketingPersonsAll: "הכל",
    marketingPersonsActive: "פעילים",
    marketingPersonsInactive: "לא פעילים",
    marketingPersonsAddPerson: "הוסף איש שיווק",
    marketingPersonsFind: "חיפוש",
    marketingPersonsOrganizerSearch: "חיפוש: שם/משפחה, טלפון (+972...), או id:123",
    marketingPersonsPeriodStart: "תחילת תקופה",
    marketingPersonsPeriodEnd: "סוף תקופה",
    marketingPersonsDownloadAllExcel: "הורד דוח כולל (Excel)",
    marketingPersonsReportSummary: "סיכום דוח",
    marketingPersonsTotalTickets: "סה״כ כרטיסים",
    marketingPersonsTotalAmount: "סה״כ סכום",
    marketingPersonsTotalCommission: "סה״כ עמלה",
    marketingPersonsEventsCount: "מספר אירועים",
    marketingPersonsTotalCount: "סה״כ:",
    marketingPersonsGridName: "שם",
    marketingPersonsGridPhone: "טלפון",
    marketingPersonsGridIDcode: "דרכון",
    marketingPersonsGridOrganizersCount: "מארגנים",
    marketingPersonsGridStartDate: "תאריך התחלה",
    marketingPersonsGridEndDate: "תאריך סיום",
    marketingPersonsGridStatus: "סטטוס",
    marketingPersonsGridActions: "פעולות",
    marketingPersonsStatusActive: "פעיל",
    marketingPersonsStatusDisabled: "מושבת",
    marketingPersonsReport: "דוח",
    marketingPersonsConfirmDeleteTitle: "אישור מחיקה",
    marketingPersonsConfirmDeleteText: "האם אתה בטוח שברצונך להסיר איש שיווק זה?",
    marketingPersonsConfirmAction: "האם אתה בטוח שברצונך לבצע פעולה זו?",
    marketingPersonsConfirmPaidTitle: "אישור שינוי סטטוס",
    marketingPersonsConfirm: "אישור",
    marketingPersonsCancel: "ביטול",
    marketingPersonsDelete: "מחק",
    marketingPersonsAddTitle: "הוסף איש שיווק",
    marketingPersonsEditTitle: "ערוך איש שיווק",
    marketingPersonsPhoneNumber: "מספר טלפון",
    marketingPersonsOrganizerId: "מזהה מארגן",
    marketingPersonsStartDate: "תאריך התחלה",
    marketingPersonsEndDate: "תאריך סיום",
    marketingPersonsDisabled: "מושבת (מוסתר)",
    marketingPersonsAdd: "הוסף",
    marketingPersonsSave: "שמור",
    marketingPersonsAdding: "מוסיף...",
    marketingPersonsSaving: "שומר...",
    marketingPersonsSelectPerson: "בחר איש שיווק",
    marketingPersonsComments: "הערות",
    marketingPersonsCommentsTitle: "הערות על המארגן",
    marketingPersonsCommentPlaceholder: "כתוב הערה על המארגן…",
    marketingPersonsCommentAdd: "הוסף הערה",
    marketingPersonsCommentsEmpty: "אין הערות עדיין",
    marketingPersonsCommentDeleteConfirm: "למחוק את ההערה?",
    marketingPersonsUnbind: "בטל שיוך מארגן",
    marketingPersonsUnbindConfirm: "לבטל את שיוך המארגן לאיש השיווק? תשלומים קיימים יישמרו.",
    marketingPersonsAlreadyAssignedTitle: "המארגן כבר משויך",
    marketingPersonsAlreadyAssignedText: "המארגן הזה כבר משויך אל:",
    marketingPersonsAlreadyAssignedQuestion: "האם לשייך את המארגן הזה שוב?",
    marketingPersonsYes: "כן",
    marketingPersonsNo: "לא",
    marketingPersonsClose: "סגור",
    marketingPersonsGridAssignments: "שיוכים",
    marketingPersonsGridAssignmentsAll: "הכל",
    marketingPersonsGridAssignmentsActive: "פעילים",
    marketingPersonsGridAssignmentsFinished: "הסתיימו",
    marketingPersonsUserFound: "משתמש נמצא",
    marketingPersonsUserCreatedNew: "משתמש חדש נוצר",
    marketingPersonsSearchOrganizer: "חיפוש מארגן",
    marketingPersonsSearchNoResult: "החיפוש נכשל",
    marketingPersonsAddAssignment: "הוסף שיוך מארגן",
    marketingPersonsClearPerson: "נקה",
    marketingPersonsTabPersons: "אנשי שיווק",
    marketingPersonsTabAssignments: "שיוכים",
    marketingPersonsAssignmentsAll: "הכל",
    marketingPersonsAssignmentsActive: "פעילים",
    marketingPersonsAssignmentsUnpaid: "לא שולם",
    marketingPersonsAssignmentsPaid: "שולם",
    marketingPersonsGridOrganizer: "מארגן",
    marketingPersonsGridCommission: "עמלה",
    marketingPersonsGridCommissionType: "סוג עמלה",
    marketingPersonsGridCommissionValue: "שיעור עמלה",
    marketingPersonsGridFee: "עמלת שירות",
    marketingPersonsGridPaid: "תשלום",
    marketingPersonsPaid: "שולם",
    marketingPersonsTabReports: "דוחות",
    marketingPersonsReportSearch: "חיפוש לפי שם או טלפון",
    marketingPersonsReportByOrganizer: "לפי מארגן",
    marketingPersonsReportByEvents: "לפי אירועים",
    marketingPersonsGridTotalFee: "עמלת שירות",
    marketingPersonsGridTotalCommission: "עמלה",
    marketingPersonsGridWorkPeriod: "תקופת עבודה",
    marketingPersonsGridEventName: "אירוע",
    marketingPersonsGridEventDate: "תאריך אירוע",
    marketingPersonsGridOrganizerName: "מארגן",
    marketingPersonsReportNoData: "אין נתוני דוח. הגדר תקופה או חיפוש לטעינה.",
    marketingPersonsSelectPeriod: "בחר טווח תאריכים לדוח האקסל (אופציונלי).",
    marketingPersonsTotalFee: "סה״כ עמלת שירות",
    marketingPersonsSearch: "חיפוש",
    marketingPersonsSearchHelper: "id:123 לפי מזהה, טלפון (+972...), או שם/משפחה",
    marketingPersonsOrganizerSelected: "נבחר",
    marketingPersonsAssignmentParams: "פרמטרי שיוך",
    marketingPersonsCommission: "עמלה",
    marketingPersonsUnpaid: "לא שולם",
    marketingPersonsReferralPaid: "עמלת הפניה שולמה",
    marketingPersonsReferralUnpaid: "עמלת הפניה לא שולמה",
    marketingPersonsGridReferralPaid: "עמלת הפניה",
    marketingPersonsDetailsOpen: "פתח",
    marketingPersonsDetailsTitle: "פרטי משווק",
    marketingPersonsBackToList: "→ חזרה לרשימה",
    marketingPersonsDetailsOrganizersSection: "מארגנים",
    marketingPersonsDetailsEventsSection: "אירועים",
    marketingPersonsOrganizerFilter: "סינון לפי עמלת הפניה",
    marketingPersonsEventFilter: "סינון לפי תשלום",
    marketingPersonsOrganizersCount: "מארגנים",
    marketingPersonsPaidCommission: "עמלה ששולמה",
    marketingPersonsUnpaidCommission: "עמלה שלא שולמה",
    marketingPersonsPaymentsSection: "תשלומים",
    marketingPersonsPaymentAdd: "הוסף תשלום",
    marketingPersonsPaymentAddTitle: "הוסף תשלום",
    marketingPersonsPaymentKind: "סוג",
    marketingPersonsPaymentKindEvent: "אירוע",
    marketingPersonsPaymentKindOrganizer: "מארגן",
    marketingPersonsPaymentMonth: "חודש",
    marketingPersonsPaymentAmount: "סכום (₪)",
    marketingPersonsPaymentNote: "הערה",
    marketingPersonsPaymentPaidAt: "שולם ב",
    marketingPersonsPaymentCreatedAt: "נוצר",
    marketingPersonsPaymentDeleteTitle: "מחק תשלום",
    marketingPersonsPaymentDeleteText: "פעולה זו תסיר את רישום התשלום ולא ניתן לבטלה.",
    marketingPersonsPaymentMonthFrom: "מחודש",
    marketingPersonsPaymentMonthTo: "עד חודש",
    marketingPersonsPaymentsReportTitle: "דוח תשלומים",
    marketingPersonsPaymentsTotalCount: "סך תשלומים",
    marketingPersonsPaymentsTotalAmount: "סכום כולל",
    headerOpenMarketingPayments: "תשלומי שיווק",
    marketingPersonsReferralCommission: "עמלת הפניה",
    marketingPersonsReferralCommissionHint: "סכום בסיסי חד-פעמי עבור הפניית מארגן זה",
    marketingPersonsPaymentKindReferral: "הפניה",
    marketingPersonsClearFilters: "נקה מסננים",
    marketingPersonsCommissionBlockTitle: "עמלה (מארגן ואירוע)",
    marketingPersonsReferralCommissionBlockTitle: "עמלת הפניה",
    marketingPersonsTotalReferralCommission: "סה״כ עמלת הפניה",
    marketingPersonsPaidReferralCommission: "עמלת הפניה ששולמה",
    marketingPersonsUnpaidReferralCommission: "עמלת הפניה שלא שולמה",
  },
};
